export default {
    data() {
        return {
            reminders: [],
            reminder_options: [
                {
                    name: this.$t('events.ten_minutes_before_start'),
                    duration: '10',
                    unit: 'minutes',
                    value: false,
                },
                {
                    name: this.$t('events.thirty_minutes_before_start'),
                    duration: '30',
                    unit: 'minutes',
                    value: false,
                },
                {
                    name: this.$t('events.hour_before_start'),
                    duration: '1',
                    unit: 'hours',
                    value: false,
                },
                {
                    name: this.$t('events.three_hours_before_start'),
                    duration: '3',
                    unit: 'hours',
                    value: false,
                },
                {
                    name: this.$t('events.one_day_before_start'),
                    duration: '1',
                    unit: 'days',
                    value: false,
                },
                {
                    name: this.$t('events.one_week_before_start'),
                    duration: '7',
                    unit: 'days',
                    value: false,
                },
            ],
        }
    },

    computed: {
        formatted_reminders() {
            const reminders = [];

            this.reminder_options.forEach(option => {
                this.reminders.forEach((reminder) => {
                    if (option.duration === reminder.duration.toString() && option.unit === reminder.unit) {
                        option.value = true;
                    }
                });
                reminders.push(option);
            })

            return reminders;
        },
    },

    methods: {
        setReminders(id, type, callback = () => {}){
            Reminder.api().fetchAllReminders(id, type).then((response) => {
                this.reminders = response.response.data.data;
                this.$emit('remindersChanged', this.reminders)
                callback();
            });
        },

        saveReminders(id, type){
            const selected_reminders = this.reminder_options.filter(option => option.value === true);

            if(selected_reminders.length >= 1) {
                Reminder.api().store(id, type, selected_reminders).then(() => {
                    this.setReminders(id, type, () => this.$emit('closeMenus'));
                });
            } else {
                Reminder.api().deleteAllReminders(id, type).then(() => {
                    this.setReminders(id, type,() => this.$emit('closeMenus'));
                })
            }
        },
    }
};
